import ko from 'knockout';
import Backbone from 'backbone';
import _ from 'underscore';
import $ from 'jquery';
import ViewModel from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsEditor/appInstallAd';
import tmpl from '@bingads-webui-campaign-legacy/crud-ad/template/adsEditor/appInstallAd.pug';
import popoverTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adsEditor/popoverTemplate.pug';
import AppLookupView from '@bingads-webui-campaign-legacy/adextension-shared/view/appLookup';
import { isCampaignApiError } from '@bingads-webui-component-legacy/api-errors-campaign/index';
import popoverExtender from '@bingads-webui-component-legacy/extension/bootstrap/popover';
import UpgradedUrl from '@bingads-webui-component-legacy/upgraded-url/view/index';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import { focusLockInstanceDecorator } from '@bingads-webui/focus-lock-decorator';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

const placeholders = {
  Text: i18n.get('Ad_Placeholder_Text'),
  Title: i18n.get('Ad_Placeholder_Title'),
  FinalUrls: i18n.get('Ad_Placeholder_FinalUrls'),
  TrackingUrlTemplate: i18n.get('Ad_Placeholder_TrackingUrlTemplate'),
};

export default class AppInstallAdEditor extends Backbone.View {
  initialize({
    model = null,
    appLookupDisabled = false,
    developerName = '',
    defaultLandingPageUrl = '',
    isForVNext = false,
    activityLogger,
  } = {}) {
    this.isForVNext = isForVNext;
    this.defaultLandingPageUrl = defaultLandingPageUrl;
    this.activityLogger = activityLogger;

    this.viewModel = new ViewModel({
      model,
      appLookupDisabled,
      developerName,
      defaultLandingPageUrl,
      activityLogger,
    });

    this.appeal = false;
    this.applookupRendered = false;
    this.applookupView = null;
    this.focusLockAppLookupPopupEditor = null;
    this.applookupLoggingInformation = '';
    this.on('created', this.handleCreated);
    this.on('cancel', this.handleCancel);
  }

  get events() {
    return {
      'click a.preview-tab': 'switchPreviewTab',
      'click .changeapp': 'changeApp',
    };
  }

  render() {
    this.$el.html(tmpl({
      i18n,
      placeholders,
      tabItems: this.viewModel.tabItems,
      isForVNext: this.isForVNext,
    }));

    ko.applyBindings(this.viewModel, this.el);

    const isFinal = true; //!!this.upgradedUrl,
    const url = isFinal ? _.first(_.result(this.model, 'FinalUrls')) : _.result(this.model, 'DestinationUrl');
    const customParameters = _.result(this.model, 'UrlCustomParameters');

    this.upgradedUrlView = new UpgradedUrl({
      url: url || this.defaultLandingPageUrl,
      isFinal,
      trackingTemplate: _.result(this.model, 'TrackingUrlTemplate'),
      finalUrlSuffix: _.result(this.model, 'FinalUrlSuffix'),
      customParameters: _.isEmpty(customParameters) ? undefined : _.clone(customParameters), // eslint-disable-line
      urlOptionsEnabled: true,
      showUurlTestTool: true,
      isMobilePreferred: true,
      entityType: 'Ad',
      isHorizontal: true,
      editMode: true,
      placeholderEnabled: true,
      popupHelpKeyAdLandingPage: 'pop_BA_AppInstall_LandingPage',
      popupHelpKeyAdTrackTemplate: 'pop_BA_AppInstall_TrackingTemplate',
      popupHelpKeyAdParameters: 'pop_BA_AppInstall_CustomParam',
      ariaPrefix: 'appInstallAd',
      isForVNext: this.isForVNext,
      activityLogger: this.activityLogger,
    });

    this.upgradedUrlView.on('finalUrlChanged', this.urlInputChanged, this);
    this.$('.app-upgraded-url').append(this.upgradedUrlView.render().el);

    this.upgradedUrlView.on('testUurl', (fn, originalView) => {
      this.trigger('testUurl', fn, originalView);
    });

    //START - remove when down stream systems are ready for DURL
    const uurlControl = this.$('.final-url');

    uurlControl.find('.radio:last').hide();
    uurlControl.find('.radio:first label').text(i18n.get('AppInstall_FinalUrl'));
    uurlControl.find('.radio:first label').css('cursor', 'default');
    uurlControl.find('.radio:first').css('padding-left', '0px');
    uurlControl.closest('.form-group').css('margin-bottom', '0px');
    //END

    return this;
  }

  resetEditMode() {
    this.viewModel.editMode(false);
  }

  changeApp() {
    if (this.viewModel.editMode()) {
      return;
    }

    this.showPopover();
  }

  showPopover() {
    const $popoverContainer = this.$el.find('.dropdownContainer:not(.fixed)');
    let flag = false;
    let tempEl = null;

    $popoverContainer
      .popover({
        container: $popoverContainer,
        trigger: 'manual',
        placement: 'bottom',
        html: true,
        template: popoverTemplate({ appSelected: this.viewModel.appSelected }),
        content: () => {
          if (flag === false) {
            this.applookupView = new AppLookupView({
              appPlatform: this.viewModel.AppPlatform() // eslint-disable-line
            });
            this.applookupView.render();
            flag = true;
            this.applookupRendered = true;
            const FocusLockAppLookupPopupEditor = focusLockInstanceDecorator(this.applookupView, {
              onExit: () => this.removePopover(),
              focusFirstItemOnMount: true,
            }, {
              managed: true,
            });

            this.focusLockAppLookupPopupEditor = new FocusLockAppLookupPopupEditor();
            tempEl = this.focusLockAppLookupPopupEditor.render().el;
          }

          return tempEl;
        },
      });

    popoverExtender.decorate($popoverContainer,
      this.excludeCb,
      _.bind(this.clickCb, this),
      _.bind(this.hiddenCb, this, null));

    $popoverContainer.popover('show');
    this.applookupView.open();
    this.applookupView.on('AppSelected', (data) => {
      this.setSelectedApp(data);
      this.removePopover();
    });
  }

  removePopover() {
    if (this.applookupView) {
      const $popoverContainer = this.$el.find('.dropdownContainer:not(.fixed)');

      $popoverContainer.popover('destroy');
      this.applookupView.clearApp();
      this.applookupView.remove();
      this.focusLockAppLookupPopupEditor.remove();
      this.applookupView = null;
      this.focusLockAppLookupPopupEditor = null;
    }
  }

  excludeCb($container, e) {
    const $target = $(e.target);

    const clikedInsideControl = $target.hasClass('dropDownSelect') ||
        $target.parents().hasClass('dropDownSelect') ||
        $.contains($container.children('.popover')[0], e.target) ||
        $container.children('.popover').find(e.target).length > 0 ||
        $target.hasClass('applookup') ||
        $target.parents().hasClass('applookup');

    const offset = 1;
    const newTop = $('.appinfo-table').height() + offset;

    $('.applookup-selected-popover .popover').css('top', `${newTop}px`);

    return Boolean(clikedInsideControl);
  }

  clickCb() {
    this.removePopover();
  }

  hiddenCb() {
    _.noop();
  }

  setSelectedApp(data) {
    // TODO: [zhbliu] give koSchema ability to bulk update model
    this.viewModel.AppPlatform(data.AppPlatform); // eslint-disable-line
    this.viewModel.AppStoreId(data.AppStoreId); // eslint-disable-line
    this.viewModel.AltText(data.AppTitle); // eslint-disable-line
    this.viewModel.MediaUrl(data.IconUrl); // eslint-disable-line
    this.viewModel.DeviceType(data.DeviceType); // eslint-disable-line

    this.viewModel.developerName(data.DeveloperName);
    this.viewModel.appSelected(true);

    this.upgradedUrlView.urlEditor.ko_model.fullUrl(data.AppUrl);

    this.applookupLoggingInformation = data.ApplookupLoggingInformation;
  }

  switchPreviewTab(target) {
    const previewType = target.currentTarget.dataset.target;

    this.viewModel.previewType(previewType);
  }

  toObject() {
    const model = this.viewModel.toObject();

    return _.extend(_.omit(model, this.viewModel.upgradedUrlFields), this.upgradedUrlView.toObject());
  }

  urlInputChanged() {
    const url = this.upgradedUrlView.urlEditor.ko_model.fullUrl();

    this.viewModel.FinalUrls(!_.isEmpty(url) ? [url] : []); // eslint-disable-line
  }

  validateViewModel() {
    const isValid = this.viewModel.validate();

    if (!isValid) {
      _.each(this.viewModel.fields, (field) => {
        if (!this.viewModel[field].isValid()) {
          if (this.activityLogger) {
            this.activityLogger.signal(`ad field invalid: ${field}`, 'app install ad editor');
          }
        }
      });
    }
    return isValid;
  }

  validate() {
    const isValid = _.reduce([
      this.upgradedUrlView.isValid(),
      this.validateViewModel(),
    ], (prev, next) => {
      return prev && next;
    }, true);

    const errorMessages = [];

    if (!this.upgradedUrlView.getValues().finalUrl.url) {
      errorMessages.push(i18n.get('Ad_AppInstall_FinalUrl_Required_Validation'));
    }

    this.upgradedUrlView.ko_model.landingPageUrlErrorMessages(errorMessages);

    return isValid;
  }

  handleApiErrors(errors) {
    this.viewModel.errors.add(errors);

    if (!_.isEmpty(errors)) {
      const errorObject = _.object(this.viewModel.upgradedUrlFields, _.map(this.viewModel.upgradedUrlFields, (key) => {
        return this.viewModel[key].errors();
      }));

      this.upgradedUrlView.handleApiErrors(errorObject);
    }
  }

  clearApiErrors() {
    this.viewModel.errors.clear(isCampaignApiError);
    this.upgradedUrlView.clearApiErrors();
  }

  handleCreated() {
    this.logAppLookupInformation('AppInstallAd/Save');
  }

  handleCancel() {
    this.logAppLookupInformation('AppInstallAd/Cancel');
  }

  logAppLookupInformation(actionName) {
    if (actionName && this.applookupLoggingInformation) {
      instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, actionName, this.applookupLoggingInformation);
    }
  }
}
